import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils, { authOptions } from 'api/requestUtils'

type StatusUpdatePath = paths['/api/lux-loyalty/account/{customerId}/status']['patch']
// A customer can only send the status; svc-lux-loyalty records its own reason for a customer re-open
type Payload = Pick<StatusUpdatePath['requestBody']['content']['application/json'], 'status'>
type Response = StatusUpdatePath['responses']['200']['content']['application/json']

async function requestLoyaltyAccountReopen(customerId: string, token?: string) {
  const response = await requestUtils.patch<Response, Payload>(
    `/api/lux-loyalty/account/${customerId}/status`,
    { status: 'active' },
    {
      ...authOptions(token),
      excludeBrand: true,
    })

  return response.result
}

export default requestLoyaltyAccountReopen
